"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewClassList = exports.ReviewClassListStyled = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const styled_components_1 = __importStar(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const component_1 = require("../../../DST/DSTT007/component");
/* ────────────────────────────────────────────────────────────────────────────
 * 학생 강의실 탭 목록 제목 — 한시 문구
 *  - 2026-11-19 까지: '기출 해설'
 *  - 2026-11-20 00:00 KST 부터: 원래 문구 '강의 다시보기' 로 복귀
 * KST 오프셋을 명시해 기기 타임존과 무관하게 같은 순간에 바뀐다.
 * 켜둔 화면도 전환 시각에 스스로 바뀐다(아래 타이머).
 * 한시 운영이 끝나면 TITLE_REVERT_AT·분기·i18n pastExamCommentary 를 함께 지우면 된다.
 * ──────────────────────────────────────────────────────────────────────────── */
const TITLE_REVERT_AT = new Date('2026-11-20T00:00:00+09:00').getTime();
/** setTimeout 의 32bit 상한(약 24.8일). 전환까지 더 남았으면 나눠 기다렸다가 다시 계산한다 */
const MAX_TIMEOUT_MS = 2147483647;
exports.ReviewClassListStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-self: stretch;
	align-items: center;
	justify-content: flex-start;
	flex: 1;
	position: relative;
	background: var(--color-white, #ffffff);
	border-radius: ${props => (props.$isMobile ? '0px' : '16px')};
	padding: ${props => (props.$isDesktop ? '32px 48px' : '20px')};

	.dropdown-container {
		display: flex;
		flex-direction: ${props => (props.$isMobile && props.$isHome ? 'column' : 'row')};
		gap: 20px;
	}

	/* 다시보기 표의 제목/검색 영역(.title-wrap)은 모바일에서 자체 20px 패딩을 갖는데(강사 목록용),
	   이 컨테이너는 이미 20px 패딩이 있어 제목·검색창만 표보다 안쪽으로 밀렸다 → 이 화면에서는 제거 */
	& .live-list .title-wrap {
		${props => props.$isMobile && 'padding: 0; gap: 10px; align-items: flex-start;'}
	}

	.live-list {
		background: var(--color-white, #ffffff);
		border-radius: 16px;
		display: flex;
		flex-direction: column;
		gap: ${props => (props.$isHome ? '20px' : '0px')};
		align-items: flex-start;
		justify-content: flex-start;
		position: relative;
		width: 100%;
		height: 100%;

		.dropdown-list {
			top: ${props => props.$isHome ? (props.$isMobile ? '53px' : '58px ') : '53px'}!important;
			max-height: ${props => (props.$isHome ? '198px ' : '171px')}!important;
		}
	}

	.review-class {
		display: flex;
		flex-direction: row;
		gap: 20px;
		/* 가운데 정렬은 홈 위젯(카드+좌우 화살표)용. 강의실 탭의 표는 카드 위쪽에 붙어야
		   위 '진행/예정 강의' 섹션과 제목 높이가 맞는다(가운데 정렬이면 min-height 342px 안에서 아래로 밀림) */
		align-items: ${props => (props.$isHome ? 'center' : 'flex-start')};
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
		/* 상단 여백은 데스크톱만. 태블릿/모바일은 컨테이너 패딩(20px)만으로 위 섹션과 줄을 맞춘다 */
		padding: ${props => (!props.$isHome && props.$isDesktop ? '23px 0' : '0')};
		width: 100%;
		height: 100%;
		flex: 1;
	}

	.review-class-list {
		background: var(--color-white, #ffffff);
		border-radius: 10px;
		border-style: solid;
		border-color: var(--color-silver, #f3f4f8);
		border-width: 1px;
		padding: 22px;
		display: flex;
		flex-direction: column;
		gap: 6px;
		align-items: flex-start;
		justify-content: center;
		flex-shrink: 0;
		override: hidden;
		position: relative;
	}

	.new {
		background: var(--color-pink, #f46790);
		border-radius: 20px;
		padding: 0px 10px 0px 10px;
		display: flex;
		flex-direction: row;
		gap: 10px;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;

		.text {
			color: var(--color-white, #ffffff);
			text-align: left;
			font-family: var(--b6-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b6-font-size, 10px);
			line-height: var(--b6-line-height, 20px);
			font-weight: var(--b6-font-weight, 400);
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
	}

	.dropdown-list {
		top: ${props => (props.$isHome ? '68px' : '106px')};
	}

	.class-title {
		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--h4-font-family, 'Noto Sans KR', sans-serif);
		font-weight: var(--h4-font-weight, 700);
		width: 100%;
	}

	.regist-date-wrapper {
		display: flex;
		flex-direction: row;
		gap: 4px;
		align-items: flex-start;
		justify-content: flex-end;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	.regist-date {
		color: var(--color-grey-w, #b6bac0);
		text-align: left;
		font-family: var(--b6-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b6-font-size, 10px);
		line-height: var(--b6-line-height, 20px);
		font-weight: var(--b6-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		min-width: 40px;
	}

	.regist-time {
		color: var(--color-grey-l, #83868a);
		text-align: left;
		font-family: var(--b6-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b6-font-size, 10px);
		line-height: var(--b6-line-height, 20px);
		font-weight: var(--b6-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		min-width: 83px;
	}

	.review-class-wrapper {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		width: 100%;
	}

	.dropdown-small {
		.dropdown-field {
			border-color: var(--color-silver, #f3f4f8);
		}
	}

	${props => (props.$isMobile ? mobileStyles : props.$isTablet ? tabletStyles : desktopStyles)}
`;
const mobileStyles = (0, styled_components_1.css) `
	gap: 12px;
	.dropdown-container {
		width: 100%;
		gap: 10px;

		.dropdown-mobile-small {
			width: 100%;

			.placeholder {
				color: var(--black, #101010);
			}
		}
		.weeks-dropdown {
			.dropdown-list {
				top: ${props => props.$isHome && '43px !important'};
			}
		}
	}

	.live-list {
		padding: ${props => (props.$isHome ? '5px' : '0px')};
	}
	.review-class-list {
		height: 135px;
	}
	.class-title {
		font-size: var(--h4-font-size, 14px);
		line-height: var(--h4-line-height, 19px);
	}
	.table-item-wrap {
		display: flex;
		gap: 24px;
		min-height: 135px;
	}
	.review-class-wrapper {
		align-items: center;
		gap: 14px;
		height: 100%;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	gap: 24px;
	.live-list {
		padding: ${props => (props.$isHome ? '5px' : '0')};
	}
	.review-class-list {
		height: 135px;
	}
	.class-title {
		font-size: var(--h4-font-size, 14px);
		line-height: var(--h4-line-height, 19px);
	}
	.review-class-wrapper {
		align-items: center;
		min-height: 135px;
		gap: 16px;
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	gap: 20px;
	.live-list {
		padding: ${props => (props.$isHome ? '5px' : '0')};
	}
	.review-class-list {
		height: 160px;
	}
	.class-title {
		font-size: var(--h4-font-size, 20px);
		line-height: var(--h4-line-height, 32px);
	}
	.review-class-wrapper {
		gap: 20px;
	}
`;
exports.ReviewClassList = react_1.default.memo(({ isHome = false }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [totalCount, setTotalCount] = react_1.default.useState(0);
    const [showCount, setShowCount] = react_1.default.useState(4);
    const [page, setPage] = react_1.default.useState(0);
    const [nextReview, setNextReview] = react_1.default.useState(0);
    // 제목 문구 전환 상태. 마운트 시점 기준으로 정하고, 전환 시각에 타이머로 한 번 더 갱신한다.
    const [isBeforeTitleRevert, setIsBeforeTitleRevert] = react_1.default.useState(() => Date.now() < TITLE_REVERT_AT);
    (0, react_1.useEffect)(() => {
        if (!isBeforeTitleRevert)
            return;
        let timer;
        const schedule = () => {
            const remain = TITLE_REVERT_AT - Date.now();
            if (remain <= 0) {
                setIsBeforeTitleRevert(false);
                return;
            }
            // 남은 기간이 상한을 넘으면 상한만큼만 기다렸다가 다시 계산(장기 미접속 탭 대응)
            timer = setTimeout(schedule, Math.min(remain, MAX_TIMEOUT_MS));
        };
        schedule();
        return () => clearTimeout(timer);
    }, [isBeforeTitleRevert]);
    const updatedData = (data) => {
        const { totalCount, count, page } = data;
        setTotalCount(totalCount);
        setShowCount(count);
        setPage(page);
    };
    (0, react_1.useEffect)(() => {
        APP.eventManager.subscribe('SEND_REVIEW_LIST', updatedData);
        return () => {
            APP.eventManager.unsubscribe('SEND_REVIEW_LIST', updatedData);
        };
    }, []);
    // > 버튼 클릭 시
    const nextButton = () => {
        APP.eventManager.publish('UPDATE_REPLAY_PAGE', page + 1);
    };
    // < 버튼 클릭 시
    const previousButton = () => {
        APP.eventManager.publish('UPDATE_REPLAY_PAGE', page - 1);
    };
    return (react_1.default.createElement(exports.ReviewClassListStyled, { "$isHome": isHome, "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile, className: "review_class_list" },
        react_1.default.createElement("div", { className: "live-list" },
            react_1.default.createElement("div", { className: "review-class" },
                react_1.default.createElement("div", { className: "review-class-wrapper" },
                    isHome && page > 0 && (react_1.default.createElement(common_1.Button, { className: `arrow active`, option: {
                            buttonBeforeIcon: {
                                show: true,
                                className: 'arrow',
                                name: 'arrow',
                                size: 24,
                                color: Colors_1.Colors.black,
                            },
                        }, styles: {
                            buttonWrap: {
                                borderRadius: '85px',
                                width: isMobile ? '27px' : '32px',
                                height: isMobile ? '27px' : '32px',
                                backgroundColor: 'white',
                                boxShadow: 'var(--shadow-bg-box-shadow, 0px 2px 6px 0px rgba(140, 143, 148, 0.4))',
                            },
                        }, onClick: previousButton })),
                    react_1.default.createElement(component_1.ReplayRoomTable, { isHome: isHome, headerTitle: !isHome
                            ? t(isBeforeTitleRevert
                                ? 'conference.pastExamCommentary'
                                : 'conference.conferenceReview')
                            : undefined }),
                    isHome && showCount * (page + 1) < totalCount && (react_1.default.createElement(common_1.Button, { className: `arrow active`, option: {
                            buttonBeforeIcon: {
                                show: true,
                                className: 'arrow-right',
                                name: 'arrow',
                                size: 24,
                                color: Colors_1.Colors.black,
                            },
                        }, styles: {
                            buttonWrap: {
                                borderRadius: '85px',
                                width: isMobile ? '27px' : '32px',
                                height: isMobile ? '27px' : '32px',
                                backgroundColor: 'white',
                                boxShadow: 'var(--shadow-bg-box-shadow, 0px 2px 6px 0px rgba(140, 143, 148, 0.4))',
                            },
                        }, onClick: nextButton })))))));
});
{
    /* <Button
                        className={`arrow active`}
                        option={{
                            buttonBeforeIcon: {
                                show: true,
                                className: 'arrow-right',
                                name: 'arrow',
                                size: 24,
                                color: Colors.black,
                            },
                        }}
                        styles={{
                            buttonWrap: {
                                borderRadius: '85px',
                                width: '32px',
                                height: '32px',
                                backgroundColor: 'white',
                                boxShadow:
                                    'var(--shadow-bg-box-shadow, 0px 2px 6px 0px rgba(140, 143, 148, 0.4))',
                            },
                        }}
                        onClick={() => nextButton()}
                    /> */
}
